module.exports = new __parcel__URL__("Project Plan Hover.579bdd0f.svg").toString();